import React from 'react'

export default React.createContext({
  isLivePreviewOpened: false,
  toggleLivePreview: () => {},
  isLivePreviewMinimized: true,
  toggleLivePreviewMinimized: () => {},
  isUserLogged: false,
  setUserLogged: () => {},
  isLoginOpened: false,
  toggleLoginOpened: () => {},
  idWatcher: null,
  setIdWatcher: () => {},
  localDataTrack: null,
  setLocalDataTrack: () => {},
  userRole: '',
  setUserRole: () => {},
})
